import { SegmentedControl } from '@/components/ui';
import { cn } from '@/lib/cn';
import type { CompareImages, ToggleSide } from './types';

interface ToggleViewProps extends CompareImages {
  side: ToggleSide;
  onSideChange: (side: ToggleSide) => void;
  fullscreen?: boolean;
}

const SIDES = [
  { value: 'original' as const, label: 'Show Before' },
  { value: 'render' as const, label: 'Show After Render' },
];

export function ToggleView({ originalImage, renderImage, side, onSideChange, fullscreen = false }: ToggleViewProps) {
  return (
    <div
      className={cn(
        'relative w-full flex items-center justify-center',
        fullscreen ? 'h-full bg-slate-950 rounded-xl p-4' : 'h-[450px] p-3',
      )}
    >
      <img
        src={side === 'original' ? originalImage : renderImage}
        alt={side === 'original' ? 'Before: raw property photo' : 'After makeover render'}
        className="max-h-full max-w-full object-contain transition-all duration-300"
        referrerPolicy="no-referrer"
      />
      <SegmentedControl
        label="Before or after"
        options={SIDES}
        value={side}
        onChange={onSideChange}
        className={cn(
          'absolute bg-black/80 border-white/10',
          fullscreen ? 'bottom-6 p-2 rounded-2xl gap-2 shadow-2xl border-white/20' : 'bottom-4 p-1.5 rounded-xl gap-2',
        )}
        itemClassName={cn('text-xs font-bold', fullscreen ? 'px-4 py-2 rounded-xl' : 'px-3 py-1 rounded-lg')}
      />
    </div>
  );
}
